import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=638f1b53&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=638f1b53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638f1b53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('638f1b53')) {
      api.createRecord('638f1b53', component.options)
    } else {
      api.reload('638f1b53', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=638f1b53&scoped=true&", function () {
      api.rerender('638f1b53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27N4qPRNYJIHo/JS/comp/DateRange.vue"
export default component.exports